import { useEffect, useState } from 'react'
import { Container, Row, Col, Modal, Button, Card } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import { useAuth } from '../../components/auth/useAuth'
import { getProtocols, addProtocol, editProtocol } from '../../actions/other/protocolsActions'
import { getTemplates } from '../../actions/other/templatesActions'
import { getAnimals } from '../../actions/other/animalsActions'
import { getUsers } from '../../actions/auth/usersActions'
import { getLots } from '../../actions/other/lotsActions'
import { CustomDataTable } from '../../components/design/Datatables/CustomDataTable'
import Swal from 'sweetalert2'
import Loader from '../../components/loaders/Loader'
import ProtocolForm from '../../components/forms/ProtocolForm'

export default function Protocols() {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const {clientauth} = useAuth()

    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(25)
    const [search, setSearch] = useState('')
    const [searchAux, setSearchAux] = useState('')
    const [totalRows, setTotalRows] = useState(0)

    const {protocols, resultprotocol, loading, total} = useSelector(state=>state.protocols)
    const {templates} = useSelector(state=>state.templates)
    const {animals} = useSelector(state=>state.animals)
    const {technicians, breeders} = useSelector(state=>state.users)
    const {lots} = useSelector(state=>state.lots)

    const [modalShow, setModalShow] = useState(false)
    const [formState, setFormState] = useState({})
    const [isRegistering, setIsRegistering] = useState(false)
    const [isAddingOrEditing, setIsAddingOrEditing] = useState(false)

    useEffect(() => {
        if(clientauth){
            dispatch(getProtocols(page, limit, search))
            dispatch(getTemplates())
            dispatch(getAnimals())
            dispatch(getUsers())
            dispatch(getLots())
        }
    },[dispatch, t, clientauth])
    
    useEffect(() => {
        if (clientauth) {
            dispatch(getProtocols(page, limit, search))
        }
    }, [page, limit, search])

    const openModal = () =>{
        setIsAddingOrEditing('adding')
        setFormState({})
        setModalShow(true)
    }

    const selectProtocol = (protocol) => {
        setFormState({...protocol})
        setIsAddingOrEditing('editing')
        setModalShow(true)
    }

    const handleInputChange = ({target})=>{
        setFormState({
            ...formState,
            [target.name]: target.value
        })
    }

    const handleSubmit= async(e) => {
        e.preventDefault()
        setIsRegistering(true)

        if(isAddingOrEditing==='editing'){
            dispatch(editProtocol(formState, formState._id))
        }else{
            dispatch(addProtocol(formState))
        }
        setIsRegistering(false)
    }

    useEffect(() => {
        if(resultprotocol){
            let resultprotocolnow = resultprotocol
            dispatch({ type: 'PROTOCOL_RESET_RESULT' })
            switch (resultprotocolnow) {
                case 'success':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('admin.protocol.addsuccess')
                    }).then(() => {
                        setModalShow(false)
                        setIsAddingOrEditing(false)
                    })
                    break;
                case 'needMoreData':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.ok'),
                        icon: 'warning',
                        text: t('admin.protocol.needMoreData')
                    })
                    break;
                case 'editSuccess':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('admin.protocol.editSuccess')
                    }).then(() => {
                        setModalShow(false)
                        setIsAddingOrEditing(false)
                    })
                    break;
                default:
                    break;
            }
        }
    // eslint-disable-next-line
    }, [resultprotocol])

    const columnsProtocol = [
        {
            name: t('admin.protocol.template'),
            cell: protocol =>
                <div className='cursor' onClick={() => selectProtocol(protocol)}>
                    {protocol.template?.name}
                </div>,
            selector: (protocol) => protocol.template?.name,
            sortable: true,
        },{
            name: t('admin.protocol.technician'),
            cell: protocol =>
                <div className='cursor' onClick={() => selectProtocol(protocol)}>
                    {protocol.technician?.name}
                </div>,
            selector: (protocol) => protocol.technician?.name,
            sortable: true,
        },{
            name: t('admin.protocol.breeder'),
            cell: protocol =>
                <div className='cursor' onClick={() => selectProtocol(protocol)}>
                    {protocol.breeder?.name}
                </div>,
            selector: (protocol) => protocol.breeder?.name,
            sortable: true,
        },{
            name: t('admin.protocol.startDate'),
            cell: protocol =>
                <div className='cursor' onClick={() => selectProtocol(protocol)}>
                    {new Intl.DateTimeFormat('es-ES', { year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date(protocol.startDate))}
                </div>,
            selector: (protocol) => protocol.startDate,
            sortable: true,
        },{
            name: '',
            width: '100px',
            cell: protocol =>
                <div className='cursor' onClick={() => selectProtocol(protocol)}>
                    <i className='fas fa-pencil'></i>
                </div>,
            sortable: false,
        }
    ]

    return (
        <Container className='p-5'>
            <Row>
                <Col xs={12}>
                    <h1>{t('admin.protocol.protocols')}</h1>
                </Col>
                <Col xs={12} className='d-flex justify-content-end'>
                    <Button variant='primary' type="submit" className="my-2 cursor" onClick={() => openModal()}>
                        <i className="fas fa-plus me-2"></i>  {t('admin.protocol.createprotocol')}
                    </Button>
                </Col>
            </Row>
            <Row>
                <Col xs={12} className='my-3'>
                    {loading ?
                        <Loader/>
                    :
                        <Row>
                            <Col>
                                <Card>
                                    <Card.Body>
                                        <div className="d-flex my-2">
                                            <input
                                                type="text"
                                                className="form-control me-2"
                                                placeholder={t("datatables.buscar")}
                                                value={searchAux || ""}
                                                onChange={e => {
                                                    setSearchAux(e.target.value);
                                                    setPage(1);
                                                }}
                                                onKeyDown={(e) => {if (e.key === 'Enter') { setSearch(searchAux); setPage(1); }}}
                                            />
                                            <Button onClick={() => setSearch(searchAux)}><i className='fas fa-search'></i></Button>
                                        </div>
                                        {protocols?.length > 0 ?
                                            <CustomDataTable
                                                columns={columnsProtocol}
                                                data={protocols}
                                                pagination
                                                paginationServer
                                                paginationTotalRows={totalRows}
                                                searchText={search}
                                                onChangeRowsPerPage={(newLimit, page) => {
                                                    if (limit !== newLimit) {
                                                        setLimit(newLimit)
                                                        setPage(1)
                                                    }
                                                }}
                                                onChangePage={(newPage) => {
                                                    setPage(newPage)
                                                }}
                                            />
                                        :
                                            <h4 className='mt-4'>{t('admin.protocol.thereisnotprotocol')}</h4>
                                        }
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    }
                </Col>
            </Row>
            <Modal
                show={modalShow}
                onHide={() => setModalShow(false)}
                aria-labelledby="contained-modal-title-vcenter"
                size="lg"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        <h2>{t('admin.protocol.protocol')}</h2>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ProtocolForm
                        state={formState}
                        protocoltype={'technical'}
                        handleInputChange={handleInputChange}
                        submit={handleSubmit}
                        isAddingOrEditing={isAddingOrEditing}
                        isRegistering={isRegistering}
                        templatesOptions={templates}
                        techniciansOptions={technicians}
                        breedersOptions={breeders}
                        animalsOptions={animals}
                        lotsOptions={lots}
                    />
                </Modal.Body>
            </Modal>
        </Container>
    )
}